module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModalArchivo) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.cerrarArchivo
    }
  }), _c('div', {
    staticClass: "modal-card modal-archivo"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_vm._m(0), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.cerrarArchivo
    }
  })]), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.archivoSeleccionado && !_vm.esPdf(_vm.archivoSeleccionado)) ? _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.archivoSeleccionado
    }
  }) : _vm._e(), (_vm.archivoSeleccionado && _vm.esPdf(_vm.archivoSeleccionado)) ? _c('iframe', {
    staticClass: "preview-pdf",
    attrs: {
      "src": _vm.archivoSeleccionado
    }
  }) : _vm._e()]), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarArchivo
    }
  }, [_vm._v("Cerrar")])])])]) : _vm._e(), _c('div', {
    staticClass: "section-news"
  }, [_vm._m(1), _c('div', {
    ref: "newsScroll",
    staticClass: "news-scroll",
    on: {
      "scroll": _vm.onNewsScroll
    }
  }, [_c('div', {
    staticClass: "news-grid"
  }, _vm._l((_vm.noticiasVisibles), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "news-card"
    }, [_c('div', {
      staticClass: "news-card-header"
    }, [(item.foto) ? _c('div', {
      staticClass: "news-file-type"
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.esPdf(item.foto) ? 'fa-file-pdf-o' : 'fa-image'
    }), _c('span', [_vm._v(_vm._s(_vm.esPdf(item.foto) ? 'PDF' : 'Imagen'))])]) : _vm._e(), _c('span', {
      staticClass: "news-badge",
      class: item.tipo
    }, [_vm._v(_vm._s(item.tipo))])]), _c('div', {
      staticClass: "news-content"
    }, [_c('h3', [_vm._v(_vm._s(item.titulo))]), _c('p', {
      staticClass: "news-description"
    }, [_vm._v(_vm._s(item.descripcion))])]), _c('div', {
      staticClass: "news-actions"
    }, [(item.foto) ? _c('button', {
      staticClass: "btn-view-file",
      on: {
        "click": function($event) {
          return _vm.abrirArchivo(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _c('span', [_vm._v("Ver archivo")])]) : _c('span', {
      staticClass: "no-file"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v("Sin archivo adjunto")])])])
  }), 0), (_vm.cargandoNoticias) ? _c('div', {
    staticClass: "news-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v("Cargando noticias...")])]) : _vm._e(), (_vm.noMore && _vm.noticiasVisibles.length) ? _c('div', {
    staticClass: "news-end"
  }, [_vm._v("No hay más noticias")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "modal-card-title"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Archivo adjunto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-header"
  }, [_c('div', [_c('h2', [_vm._v("Últimas noticias")]), _c('p', [_vm._v("Mantente informado de comunicados, capacitaciones y novedades importantes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e933060","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_noticias.vue
// module id = 818
// module chunks = 0